import {
  AmbassadorRecord,
  CreateAmbassadorRequest,
  RepresentationTypes,
  UpdateAmbassadorRequest,
} from '@amzn/red-velvet-api';
import { AmbassadorRegistrationFormValues } from '../components/ambassadors/ambassadorRegistrationForm';
import { TFunction } from 'i18next';

export const ambassadorFormValuesToRequest = (
  values: AmbassadorRegistrationFormValues,
  alias = '',
  t: TFunction<'translation', undefined>
): CreateAmbassadorRequest => {
  const representationTypes: RepresentationTypes[] = [];
  if (values.siteRepresentation) {
    representationTypes.push(RepresentationTypes.SITE);
  }
  if (values.teamRepresentation) {
    representationTypes.push(RepresentationTypes.TEAM);
  }
  if (values.employeeLedGroupRepresentation) {
    representationTypes.push(RepresentationTypes.ELG);
  }

  return {
    alias,
    representationTypes: representationTypes,
    heardAbout:
      values.howDidYouHear?.label === t('ambassadorRegistration.otherPleaseSpecify')
        ? [values.howDidYouHearSpecification]
        : [values.howDidYouHear?.label || ''],
    representedSiteCodes: values.representedSiteCodes.length
      ? values.representedSiteCodes.map((sc) => sc.value || '')
      : undefined,
    teamLocation: values.teamLocation?.length
      ? values.teamLocation?.map((tl) => tl.value || '')
      : undefined,
    teamName: values.teamName ?? undefined,
    ergName: values.ergName?.value ? [values.ergName.value] : undefined,
    ergLocation: values.ergLocation?.length
      ? values.ergLocation?.map((ergL) => ergL.value || '')
      : undefined,
  };
};

export const buildAmbassadorDirectoryOptions = (
  ambassadors: AmbassadorRecord[],
  propertyToAggregate: string
) => {
  const unique = new Set();

  if (ambassadors.length) {
    for (let i = 0; i < ambassadors.length; i++) {
      const obj = ambassadors?.[i];
      // Ensure object is non-null and has its own siteCode property
      if (obj && Object.prototype.hasOwnProperty.call(obj, propertyToAggregate)) {
        const code = obj[propertyToAggregate as keyof typeof obj];
        // Skip undefined/null; convert to string for the final string array
        if (code != null) {
          unique.add(String(code));
        }
      }
    }
  }

  // Convert Set to array (in insertion order)
  return Array.from(unique)
    .sort()
    .map((u) => ({ value: u as string, label: u as string }));
};

// this is different from above because we send employeeId instead of alias and dont send heardAbout
export const ambassadorFormValuesToUpdateRequest = (
  values: AmbassadorRegistrationFormValues,
  employeeId = ''
): UpdateAmbassadorRequest => {
  const representationTypes: RepresentationTypes[] = [];
  if (values.siteRepresentation) {
    representationTypes.push(RepresentationTypes.SITE);
  }
  if (values.teamRepresentation) {
    representationTypes.push(RepresentationTypes.TEAM);
  }
  if (values.employeeLedGroupRepresentation) {
    representationTypes.push(RepresentationTypes.ELG);
  }

  return {
    employeeId,
    representationTypes: representationTypes,
    representedSiteCodes: values.representedSiteCodes.length
      ? values.representedSiteCodes.map((sc) => sc.value || '')
      : undefined,
    teamLocation: values.teamLocation?.length
      ? values.teamLocation?.map((tl) => tl.value || '')
      : undefined,
    teamName: values.teamName ?? undefined,
    ergName: values.ergName?.value ? [values.ergName.value] : undefined,
    ergLocation: values.ergLocation?.length
      ? values.ergLocation?.map((ergL) => ergL.value || '')
      : undefined,
  };
};
